import { useEffect, useRef } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";
import "../css/leaflet-ruler.css";
import "../js/leaflet-ruler";

export default function LeafletRuler() {
  const map = useMap();
  const widgetAdded = useRef(false);

  useEffect(() => {
    if (!map || widgetAdded.current) return;

    L.control.ruler().addTo(map);
    widgetAdded.current = true;
  }, [map]);

  return null;
}
